import React from 'react'
import { useState, useEffect } from 'react'
import Layouts from '../src/components/Layouts'
import {
  Form,
  Col,
  Select,
  Row,
  Table,
  Input,
  Tooltip,
  Button,
  Modal,
  Space,
} from 'antd'
import { Link } from 'react-router-dom'
import ViewClaimModel from '../src/ViewClaimModel'
import { Spin, Tag } from 'antd'
import apiRequest from './hooks/apiRequest'
import { toast } from 'react-toastify'
import {
  AuditOutlined,
  UploadOutlined,
  FileTextOutlined,
  MoneyCollectOutlined,
  CheckOutlined,
  DollarCircleOutlined,
  EyeOutlined,
  CheckCircleOutlined,
  EditOutlined,
} from '@ant-design/icons'
import ViewRejectedClaim from './ViewRejectedClaim'
import ViewPolicyDetailsForFC from './ViewPolicyDetailsForFC'
import ViewPolicyClaim from './ViewPolicy'
import ClaimActivity from './ClaimActivity'
import RoleIDMapping from './hooks/Modules'
import { useParams } from 'react-router-dom'
import ApproveClaimModal from './pages/ClaimView'

export default function Claims() {
  const [resData, setresData] = useState([])
  const [viewClaim, setViewClaim] = useState(false)
  const [viewRejectedClaim, setViewRejectedClaim] = useState(false)
  const [paymentApproval, setPaymentApproval] = useState(false)
  const [loading, setLoading] = useState(true)
  const [claimId, setClaimId] = useState([])
  const [filterTable, setFilterTable] = useState([])
  const [paymentPopup, setPaymentPopup] = useState(false)
  const [policyData, setPolicyData] = useState()
  const [policyDataForFinance, setPolicyDataForFinance] = useState()
  const [viewPolicy, setViewPolicy] = useState(false)
  const [claimActivity, setClaimActivity] = useState()
  const [insurerId, setInsurer] = useState('')
  const [userId, setUserId] = useState('')
  const [userEmail, setUserEmail] = useState('')
  const [isClaimActivityOpen, setIsClaimActivityOpen] = useState(false)
  const [isInsurerApproveClaim, setIsInsurerApproveClaim] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const userRole = JSON.parse(localStorage.getItem('roles'))
  const loginUserRole = JSON.parse(localStorage.getItem('user'))?.role

  const [approveModalOpen, setApproveModalOpen] = useState(false)
  const [approvedAmount, setApprovedAmount] = useState("")
  const [approvedNotes, setApprovedNotes] = useState("")
  const [selectedClaim, setSelectedClaim] = useState(null)
  const [decision, setDecision] = useState("Approve");



  const { claimNumber } = useParams()
  function assignAccessor(value) {
    setInsurer(value?.insurerId)
    setClaimId(value)
    setVisible()
  }

  function viewRejected(val) {
    setClaimId(val)
    setVisible2()
  }

  const handleApproveSubmit = async () => {
    debugger;
    try {
      if (!selectedClaim) return;

      const claimId = selectedClaim.id;



      const nextStatus = decision === "Approve" ? 6 : 1;

      const req1 = await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Claim/UpdateClaim/update-claim/${claimId}`,
        "POST",
        {
          status: nextStatus,
          Notes: approvedNotes,
          ApprovedAmount: parseFloat(approvedAmount),

        }
      );
      const req2 = await apiRequest(`${process.env.REACT_APP_BASE_URL}/Claim/ApproveClaim/approve-claim?claimId=${claimId}`, "POST");

      toast.success("Claim approved successfully!");
      setApproveModalOpen(false);
      window.location.reload();


    } catch (err) {
      toast.error("Error approving claim");
    }

  };


  const fetchPreviousApproval = async (claimId) => {
    const res = await apiRequest(
      `${process.env.REACT_APP_BASE_URL}/Claim/GetClaimById/${claimId}`,
      "GET"
    );

    if (res.success) {
      const savedAmount =
        res.data.result?.approved_amount ||
        res.data.result?.claim_creation?.approved_amount ||
        0;

      const savedNotes =
        res.data.result?.approved_notes ||
        res.data.result?.claim_creation?.claim_notes || "";
      setApprovedAmount(savedAmount);
      setApprovedNotes(savedNotes);
    }
  };

  function authorise(value) {
    localStorage.setItem('claimId', value)
    window.location.href = '/authoriseClaim'
  }

  async function payAmount(value) {
    try {
      setLoading(true)
      setPaymentPopup(true)
      debugger

      const claimRes = await apiRequest(
        process.env.REACT_APP_BASE_URL + `/Claim/GetClaimById/${value}`,
        'GET',
      )
      // const claimData = await claimRes.json()
      console.log(
        'claimRes.data.result.claim_creation',
        claimRes.data.result.claim_creation,
      )
      const claimInfo = claimRes.data.result.claim_creation
      const policyNumber = claimInfo.policy_number
      let productId = null
      let policyUrl = ''
      let policyRes, policyData, dataForFinance

      let activityData = claimRes.data.result.claim_activity
      setClaimActivity(activityData)

      if (policyNumber.includes('OTM')) {
        policyRes = await fetch(
          `http://64.227.72.205:5001/api/v1/policy/${policyNumber}`,
        )
        policyData = await policyRes.json()

        dataForFinance = {
          product: 'Motor Insurance',
          policyNumber: policyData.policy_number,
          customerName: `${policyData.first_name} ${policyData.surname}`,
          VRN: policyData.vrn,
          riskItemDetails: '',
          nationalId: policyData.id_number,
          policyStartDate: policyData.policy_start_date,
          policyEndDate: policyData.policy_end_date,
          policyPremium: policyData.premium,
        }
      } else {
        if (policyNumber.includes('OTAAR')) productId = 1
        else if (policyNumber.includes('OTDC')) productId = 2
        else if (policyNumber.includes('OTFCP')) productId = 3

        policyRes = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_POLICIES}/Policy/GetPolicybynumber/${policyNumber}`,
        )
        policyData = policyRes.data

        const details = policyData.policydetail
        dataForFinance = {
          product: details.productname,
          policyNumber: details.policynumber,
          customerName: details.customername,
          VRN: '',
          riskItemDetails: details.riskitemdetails,
          nationalId: details.nationalid,
          policyStartDate: details.policystartdate,
          policyEndDate: details.policyexpirytdate,
          policyPremium: details.proratatotaltermpremium,
        }
      }

      const totalData = {
        claimInfo,
        ...dataForFinance,
        activityData,
      }

      console.log('totalData to be set:', totalData)

      setPolicyDataForFinance(totalData)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setLoading(false)
    }
  }
  function generateAssessorReport(value) {
    localStorage.setItem('claimId', value)
    window.location.href = '/generateAssessor'
  }

  function claimActivityView(value) {
    localStorage.setItem('claimId', value)
    setIsClaimActivityOpen(true)
  }

  const fetchDocument = async claimNumber => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_DOCUMENT}/Document/ByEntity/${claimNumber}/0`,
        'GET'
      );

      if (response.success && response?.data?.data?.length > 0) {
        response.data.data.forEach((doc, index) => {
          setTimeout(() => {
            const url = `https://devsageninsurance.blob.core.windows.net/claim-doc/${doc.filePath}`;


            // 🔹 Trigger file download
            const link = document.createElement('a');
            link.href = url;
            link.download = doc.documentName || 'document';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }, index * 1000); // wait 1 second between downloads
        });

        toast.success('All documents downloaded.');
      } else {
        toast.warn('No documents found for this claim.');
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      toast.error('Something went wrong while fetching documents.');
    }
  };

  function documentUpload(value) {
    debugger
    console.log(value)
    localStorage.setItem('claimId', value.id)
    window.location.href = `/upload-documents/${value.id}/${value.claim_number}/${value.productId}/${value.insurerId}`
  }

  function setVisible() {
    setViewClaim(true)
  }
  function setVisible2() {
    setViewRejectedClaim(true)
  }

  function setVisibleFalse() {
    setViewClaim(false)
    localStorage.removeItem('claimNumber')
    //window.location.reload(false)
  }
  function setVisibleFalse2() {
    setViewRejectedClaim(false)
    localStorage.removeItem('claimNumber')
    window.location.reload(false)
  }
  function setVisibleFalse3() {
    setPaymentApproval(false)
  }
  function setVisibleFalse4() {
    setPaymentPopup(false)
  }
  function setVisibleFalse5() {
    setIsClaimActivityOpen(false)
  }

  const columns = [
    {
      title: 'Claim Number',
      dataIndex: 'claim_number',
      key: '1',
    },
    {
      title: 'Policy No.',
      //dataIndex: 'policy_number',
      key: '2',
      render: (_, record) => (
        <Tooltip title="View Policy">
          {' '}
          <a onClick={() => ViewPolicyF(record.policy_number)}>
            {record.policy_number}
          </a>
        </Tooltip>
      ),
    },
    {
      title: 'Item Details',
      dataIndex: 'itemdetails',
      key: '3',
    },
    {
      title: 'Loss Date',
      dataIndex: 'date_of_loss',
      key: '5',
    },
    {
      title: 'Notification Date',
      dataIndex: 'date_of_notification',
      key: '6',
    },
    {
      title: 'Claim Amt.',
      dataIndex: 'claim_amount',
      key: '7',
    },
    {
      title: 'Claim Status',
      key: '8',
      render: record => <Tag color="blue">{record.claim_status}</Tag>,
    },
    {
      title: 'Assessor',
      key: '9',
      dataIndex: 'accessor_name',
    },
    {
      title: 'Approved Amt.',
      dataIndex: 'approved_amount',
      key: '10',
    },
    {
      title: 'Created Date',
      dataIndex: 'created_date',
      key: '11',
    },
    {
      key: '12',
      title: 'Action',
      render: record => (
        <div style={{ display: 'flex' }}>
          {/* Always visible: Claim Activity button */}
          <Tooltip title="View Claim Activity">
            <button
              className="ant-btn edit_btn ant-btn-primary"
              style={{
                backgroundColor: '#1890ff',
                marginRight: 8,
              }}
              onClick={() => claimActivityView(record.id)}>
              <EyeOutlined />
            </button>
          </Tooltip>



          {/* 🔹 Download Claim Documents Button */}
          <Tooltip title="Download Claim Documents">
            <button
              className="ant-btn edit_btn ant-btn-primary"
              style={{
                backgroundColor: '#ff7a00', // orange shade
                borderColor: '#ff7a00',
                color: '#fff',
                marginRight: 8,
              }}
              //Pass correct claim_number or id for document fetching
              onClick={() => fetchDocument(record.claim_number)}
            >
              <FileTextOutlined /> {/* changed icon for better clarity */}
            </button>
          </Tooltip>
          {/* Conditional: Upload button for Registered claims */}
          {record.customer_email === userEmail &&
            record.claim_status === 'Document_Required' && (
              <Tooltip title="Documents">
                <button
                  className="ant-btn edit_btn ant-btn-primary"
                  style={{
                    backgroundColor: 'green',
                    marginRight: 8,
                  }}
                  onClick={() => documentUpload(record)}>
                  <UploadOutlined />

                </button>
              </Tooltip>
            )}

          {/* Conditional: Assessor Report for Junior Underwriter */}
          {record.claim_status === 'Awaiting Authorisation' &&
            record.accessor_id === 0 &&
            record.validation_status === true &&
            userRole === 'Junior_Underwriter' && (
              <Tooltip title="Generate Assessor Report and Finalise Claim Amount">
                <button
                  className="ant-btn edit_btn ant-btn-primary"
                  style={{
                    backgroundColor: 'red',
                    marginRight: 8,
                  }}
                  onClick={() => generateAssessorReport(record.id)}>
                  <MoneyCollectOutlined />
                </button>
              </Tooltip>
            )}

          {record.claim_status === 'Awaiting Authorisation' &&
            record.accessor_id === userId &&
            record.validation_status === true &&
            (userRole === 'FINANCE_MANAGER' || userRole === 'UnderWriter') && (
              <Tooltip title="Generate Assessor Report and Finalise Claim Amount">
                <button
                  className="ant-btn edit_btn ant-btn-primary"
                  style={{
                    backgroundColor: 'red',
                    marginRight: 8,
                  }}
                  onClick={() => generateAssessorReport(record.id)}>
                  <MoneyCollectOutlined />
                </button>
              </Tooltip>
            )}
          {record.claim_status === 'Draft' &&
            loginUserRole == RoleIDMapping('Broker') && (
              <Tooltip title="Generate Claim">
                <Link
                  to={`/EditClaim/${record?.policy_number}`}
                  className="ant-btn edit_btn ant-btn-primary"
                  style={{ padding: '8px 6px', fontSize: '12px', lineHeight: 1 }}>
                  <EditOutlined />
                </Link>
              </Tooltip>
            )}
          {((record.claim_status === 'Registered' ||
            record.claim_status === 'Waiting_for_Esclator_Authorization') &&
            (loginUserRole != RoleIDMapping('Insurer') &&
              loginUserRole != RoleIDMapping('Customer')) ||
            (record.claim_status === 'Approved' &&
              loginUserRole === RoleIDMapping('Insurer'))) && (

              <Tooltip title="Approve Claim">
                <button
                  className="ant-btn ant-btn-primary"
                  style={{ padding: "8px 6px", fontSize: "12px", lineHeight: 1 }}
                  onClick={() => {
                    debugger;
                    if (userRole.toLowerCase() === 'insureradmin') {
                      setSelectedClaim(record);
                      fetchPreviousApproval(record.id);
                      window.location.href = `/approve-claim/${record.id}/${record.policy_number}`;
                    }
                    else {
                      setSelectedClaim(record);
                      fetchPreviousApproval(record.id);
                      setApproveModalOpen(true);
                    }
                  }}
                >
                  <CheckCircleOutlined style={{ fontSize: "14px" }} />
                </button>
              </Tooltip>
            )}

        </div>
      ),
    },
  ]

  async function ViewPolicyF(val) {
    let apiData
    let productId
    setLoading(true)

    try {
      if (val.includes('OTM')) {
        const data = await apiRequest(
          'http://64.227.72.205:5001/api/v1/policy/' + val,
          'GET',
        )

        apiData = {
          productName: 'Motor Insurance',
          policyNo: data.policy_number,
          policyStartDate: data.policy_start_date,
          policyEndDate: data.policy_end_date,
          sumInsured: data.sum_insured,
          customerName: data.first_name + ' ' + data.surname,
          riskItemDetails: '',
          vrn: data.vrn,
        }
      } else {
        if (val.includes('OTAAR')) {
          productId = 1
        } else if (val.includes('OTDC')) {
          productId = 2
        } else if (val.includes('OTFCP')) {
          productId = 3
        }

        const data = await apiRequest(
          process.env.REACT_APP_BASE_URL_POLICIES +
          '/Policy/GetPolicybynumber/' +
          val,
          'GET',
        )

        apiData = {
          productName: data.data.policydetail.productname,
          policyNo: data.data.policydetail.policynumber,
          policyStartDate: data.data.policydetail.policystartdate,
          policyEndDate: data.data.policydetail.policyexpirytdate,
          sumInsured: '',
          customerName: data.data.policydetail.customername,
          riskItemDetails: data.data.policydetail.riskitemdetails,
        }
      }

      setPolicyData(apiData)
    } catch (error) {
      console.error('Error fetching policy data:', error)
    } finally {
      setLoading(false)
      setViewPolicy(true)
    }
  }

  function setViewPolicyVisibleFalse() {
    setViewPolicy(false)
  }

  useEffect(() => {
    const fetchClaims = async () => {
      try {
        setLoading(true);

        const url = process.env.REACT_APP_BASE_URL + '/claim/GetAllClaims/';
        const response = await apiRequest(url, 'GET');

        if (!response?.success) {
          console.error("API error:", response?.error);
          return;
        }

        const data = response?.data?.result || [];

        const email = JSON.parse(localStorage.getItem("user"))?.email || "";
        const userType = JSON.parse(localStorage.getItem("roles"));
        const userId = parseInt(localStorage.getItem("loggedInUserID"));
        setUserId(userId);
        setUserEmail(email);

        let apiData = [];

        const filtered = data.filter(d => {
          if (!d?.claim_creation) return false;

          if (userType === "Broker")
            return d.claim_creation.brokerId === userId;

          if (userType === "InsurerAdmin")
            return d.claim_creation.insurerId === userId;

          if (userType === "Customer")
            return d.claim_creation.customer_email === email;

          return d.claim_creation.accessor_id === userId;
        });

        apiData = filtered.map(d => ({
          ...d.claim_creation,
          claim_activity: d.claim_activity
        }));

        setresData(apiData);
      } catch (err) {
        console.error("UNEXPECTED ERROR:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchClaims();
  }, []);

  useEffect(() => {
    if (!claimNumber) return;
    if (!resData || resData.length === 0) return;

    search(claimNumber);
  }, [claimNumber, resData]);

  const search = (value) => {
    setSearchValue(value);

    const lower = value.toLowerCase();

    const searchRes = resData.filter(o =>
      Object.keys(o).some(k =>
        (o[k] ?? "").toString().toLowerCase().includes(lower)
      )
    );

    setFilterTable(searchRes);
  };


  return (
    <Layouts title="assets" classname="grid">
      <Spin
        className="loader-icon-fixed"
        spinning={loading}
        size="large"></Spin>
      <div>
        <div className="dash-bg-white">
          <Row gutter={[16, 16]}>
            <Col xs={12} sm={24} md={24} lg={12}>
              <div className="section-top-heading">
                <h3
                  style={{
                    color: '#0C1362',
                    fontWeight: '600',
                    fontSize: '20px',
                  }}>
                  {' '}
                  Claims List{' '}
                </h3>
              </div>
            </Col>
            <Col xs={12} sm={24} md={24} lg={8}>
              <div className="item-search">
                <Form.Item>
                  {' '}
                  <Input.Search
                    placeholder="Search ..."
                    enterButton
                    onSearch={search}
                    value={searchValue}
                    onChange={e => setSearchValue(e.target.value)}
                  />{' '}
                </Form.Item>
              </div>
            </Col>
            {localStorage.getItem('userType') === 'CLAIMS_PROCESSOR' && (
              <Col xs={12} sm={24} md={24} lg={4}>
                <div className="create-quotation">
                  <Link to="/ClaimCreation" className="btn btn-primary">
                    Generate Claim
                  </Link>
                </div>
              </Col>
            )}
            {localStorage.getItem('userType') === 'CLAIMS_MANAGER' && (
              <Col xs={12} sm={24} md={24} lg={4}>
                <div className="create-quotation">
                  <Link to="/ClaimCreation" className="btn btn-primary">
                    Generate Claim
                  </Link>
                </div>
              </Col>
            )}
          </Row>
        </div>
        <div className="table-grid-bx">
          {' '}
          <Table
            columns={columns}
            dataSource={filterTable.length > 0 ? filterTable : resData}
            scroll={{
              x: 500,
            }}
          />

          <Modal
            title="Approve Claim"
            centered
            visible={approveModalOpen}
            onCancel={() => setApproveModalOpen(false)}
            onOk={handleApproveSubmit}
            okText="Submit"
          >
            <Form layout="vertical">

              {/* Decision Dropdown */}
              <Form.Item label="Decision">
                <Select
                  value={decision}
                  onChange={(value) => setDecision(value)}
                >
                  <Select.Option value="Approve">Approve</Select.Option>
                  <Select.Option value="Decline">Decline</Select.Option>
                </Select>
              </Form.Item>

              {/* Approved Amount — Only show when APPROVE is selected */}
              {decision === "Approve" && (
                <Form.Item label="Approved Amount">
                  <Input
                    value={approvedAmount}
                    onChange={(e) => setApprovedAmount(e.target.value)}
                    type="number"
                  />
                </Form.Item>
              )}

              {/* Notes (Always visible) */}
              <Form.Item label="Notes">
                <Input.TextArea
                  value={approvedNotes}
                  onChange={(e) => setApprovedNotes(e.target.value)}
                  rows={4}
                />
              </Form.Item>

            </Form>
          </Modal>

        </div>
      </div>



      <Modal
        title={`Claim ${localStorage.getItem('ModalTitle')}`}
        centered
        visible={viewClaim}
        footer={null}
        onCancel={setVisibleFalse}
        width={1400}>
        <ViewClaimModel
          parentToChild={claimId}
          insurerId={insurerId}
          closeModale={() => setViewClaim(false)}
        />
      </Modal>
      <Modal
        title={
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
            }}>
            Claim Details
          </h3>
        }
        centered
        visible={viewRejectedClaim}
        footer={null}
        onCancel={setVisibleFalse2}
        width={1200}>
        <ViewRejectedClaim parentToChild={claimId} />
      </Modal>
      <Modal
        title={
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
            }}>
            Policy/Claim Details
          </h3>
        }
        centered
        visible={paymentApproval}
        footer={null}
        onCancel={setVisibleFalse3}
        width={1200}>
        <ViewPolicyDetailsForFC
          parentToChild={policyDataForFinance}
          onCloseModal={setVisibleFalse3}
          onCloseModal2={setVisibleFalse4}
        />
      </Modal>
      <Modal
        title={
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
            }}>
            Policy/Claim Details
          </h3>
        }
        centered
        visible={paymentPopup}
        footer={null}
        onCancel={setVisibleFalse4}
        width={1200}>
        {policyDataForFinance && policyDataForFinance.claimInfo ? (
          <ViewPolicyDetailsForFC
            parentToChild={policyDataForFinance}
            onCloseModal={setVisibleFalse3}
            onCloseModal2={setVisibleFalse4}
          />
        ) : (
          <p>Loading data...</p>
        )}
      </Modal>
      <Modal
        title={
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
            }}>
            Policy Details
          </h3>
        }
        centered
        visible={viewPolicy}
        footer={null}
        onCancel={setViewPolicyVisibleFalse}
        width={1200}>
        <ViewPolicyClaim parentToChild={policyData} />
      </Modal>
      <Modal
        title="Claim Activity"
        centered
        visible={isClaimActivityOpen}
        footer={null}
        onCancel={setVisibleFalse5}
        width={1200}>
        <ClaimActivity visible={isClaimActivityOpen} />
      </Modal>


    </Layouts>
  )
}
